import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {StaffMember} from '../../../types/StaffMember';

@Component({
  selector: 'app-cpru-staff-list',
  templateUrl: './cpru-staff-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruStaffListComponent {
  staffMembers = input<StaffMember[]>(null);
  expanded = signal<boolean>(false);
  showExpandButton = computed<boolean>(() => this.staffMembers().length > 4 && !this.expanded());
  staffMembersToDisplay = computed<StaffMember[]>(() => {
    return this.staffMembers().slice(0, this.expanded() ? this.staffMembers().length : 4);
  });

  public toggleExpanded() {
    this.expanded.set(!this.expanded());
  }
}
